import { FunctionComponent, SyntheticEvent } from 'react';
import playAudio from '~frontend/utils/playAudio';
import { SteamItemImage } from '../item';
import { Price } from '~ui/Price';

import { useItemRight, useStatusGame } from './hooks';

import Currency from '../Currency';
import { useConfig } from '~components/hooks';

const UpgradeRight: FunctionComponent = () => {
  const [itemRight, setItemsRight] = useItemRight();
  const [, statusGame] = useStatusGame();
  const getConfig = useConfig();

  const removeItemFromUpgrade = (event: SyntheticEvent) => {
    event.preventDefault();

    setItemsRight(null);
    statusGame(0);
    playAudio(null, '14.mp3', 0.4);
  };

  return (
    <div className={`upgrade-main-right ${itemRight && 'active'}`}>
      <div className="item">
        {itemRight && (
          <div
            className="in-case-item status-1"
            onClick={removeItemFromUpgrade}
            data-id={itemRight.id}
            onMouseEnter={playAudio}
            data-audio="5.wav"
            data-volume="0.4"
          >
            <a className="close" href="#">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <circle cx="10" cy="10" r="10" fill="#750881"></circle>
                <path
                  d="M2211,75.713l-4.3,4.3-.717-.715,4.3-4.3-4.3-4.3.717-.716,4.3,4.3,4.3-4.3.716.716-4.3,4.3,4.3,4.3-.716.715Z"
                  transform="translate(-2201 -65)"
                  fill="#f0a1ff"
                ></path>
              </svg>
            </a>
            <div
              className="in-case-item active status-1"
              data-rar={itemRight.color}
              data-audio="5.wav"
              data-volume="0.4"
            >
              <div className="in-case-cost">
                {getConfig.isEU ? (
                  <>
                    <Currency />
                    <Price sum={itemRight.price} />
                  </>
                ) : (
                  <>
                    <Price sum={itemRight.price} />
                    <Currency />
                  </>
                )}
              </div>
              <div className="in-case-item-wrap">
                <div className="img">
                  <div className="in-case-item-bg" />
                  <SteamItemImage url={itemRight.getImage} size="350x350" />
                </div>
                <div className="in-case-info">
                  <div className="in-case-item-name">{itemRight.getName}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpgradeRight;
